import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedPipesModule } from '../shared-pipes/shared-pipes.module';
import { SharedUiModule } from '../shared-ui/shared-ui.module';
import { FlightSeatMapTabComponent } from '../../../results/components/flights/flight-extras-dialog/flight-seat-map-tab/flight-seat-map-tab.component';
import { FlightSeatMapComponent } from '../../../results/components/flights/flight-extras-dialog/flight-seat-map/flight-seat-map.component';
import { FlightExtrasComponent } from '../../../results/components/flights/flight-extras-dialog/flight-extras/flight-extras.component';
import { FlightAmenitiesComponent } from '../../../results/components/flights/flight-extras-dialog/flight-amenities/flight-amenities.component';
import { FlightExtrasRecalculateComponent } from '../../../results/components/flights/flight-extras-dialog/flight-extras-recalculate/flight-extras-recalculate.component';

/**
 * Shared home for the flight seat-map / extras / amenities UI.
 *
 * These components are used both by `FlightExtrasDialogComponent` (results/results.module,
 * the normal modal booking flow) and by the inline chatbot flight-extras card
 * (startup/startup.module, the chatbot booking flow). Extracting them here avoids a
 * circular NgModule dependency, since `ResultsModule` imports `StartupModule` and therefore
 * `StartupModule` cannot import `ResultsModule` back.
 */
const components = [
  FlightSeatMapTabComponent,
  FlightSeatMapComponent,
  FlightExtrasComponent,
  FlightAmenitiesComponent,
  FlightExtrasRecalculateComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    SharedPipesModule,
    SharedUiModule
  ],
  declarations: components,
  exports: components
})
export class FlightSeatMapSharedModule {}
